import { Button } from "@mantine/core";
import { useState } from "react";
import ReactDOM from "react-dom";
import { BasicConfirmationModal } from "../../../BuildingBlocks/Layout/Modals/BasicConfirmationModal/BasicConfirmationModal";

interface SiteFormControlsProps {
  buttonContainer?: HTMLElement;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
  askForConfirmation: boolean;
}

function SiteFormControls({
  buttonContainer,
  onCancel,
  onSubmit,
  askForConfirmation
}: SiteFormControlsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  function handleClickSubmit() {
    if (askForConfirmation) {
      setIsConfirmationOpen(true);
    } else {
      handleSubmit();
    }
  }

  async function handleSubmit() {
    setIsSubmitting(true);

    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="SiteFormControls">
      {buttonContainer &&
        ReactDOM.createPortal(
          <>
            <Button variant="default" onClick={onCancel}>
              Abbrechen
            </Button>
            <Button
              color="primary"
              loading={isSubmitting}
              onClick={handleClickSubmit}
            >
              Speichern
            </Button>
          </>,
          buttonContainer
        )}
      <BasicConfirmationModal
        confirmationButtonColor="warning"
        confirmationButtonText="Ja, erstellen"
        opened={isConfirmationOpen}
        title={`Wollen Sie die Liegenschaft erstellen?`}
        toggleModal={() => setIsConfirmationOpen(!isConfirmationOpen)}
        onCancel={() => setIsConfirmationOpen(false)}
        onConfirm={() => {
          handleSubmit();
          setIsConfirmationOpen(false);
        }}
      >
        Bitte beachten Sie, dass einige Daten unvollständig oder fehlerhaft sein
        werden. Sie können die Liegenschaft jetzt erstellen und die Daten
        jederzeit später aktualisieren.
      </BasicConfirmationModal>
    </div>
  );
}

export { SiteFormControls, SiteFormControlsProps };
